import { IconClock, IconMapPin } from "../../../components/icons/IconsPaciente";
import { EmptyState } from "../../../components/utils/Utils";
import { BadgeCobertura } from "./BadgeCobertura";
import { getCoberturaParaServicio, calcularCostoConCobertura } from "./CoberturaUtils";
import { formatearHora } from "./buscarTurnoHelpers";

// Paso 4: turnos de la fecha elegida. Por cada servicio del turno se muestra la
// cobertura del plan del paciente y el monto a abonar. Al reservar se pide
// confirmacion (el modal lo maneja el orquestador).
const PasoTurno = ({ turnos, plan, onReservar, deshabilitado }) => (
    <div className="wizard-paso">
        <h3 className="wizard-paso__titulo">Elegí un turno</h3>

        {plan ? (
            <p className="plan-aviso plan-aviso--con-plan">✓ Plan activo: <strong>{plan.nombre}</strong></p>
        ) : (
            <p className="plan-aviso plan-aviso--sin-plan">
                ⚠ No tenés un plan de cobertura. Los servicios se cobran a precio completo.
            </p>
        )}

        {turnos.length === 0 ? (
            <EmptyState icon={<IconClock />} title="No hay turnos disponibles en esta fecha." />
        ) : (
            <div className="disponibilidad-grid">
                {turnos.map((turno) => (
                    <div 
                        key={turno.id} 
                        className={`disponibilidad-card ${deshabilitado ? 'disponibilidad-card--disabled' : ''}`}
                        onClick={() => {
                            if (!deshabilitado) onReservar(turno);
                        }}
                    >
                        <div className="disponibilidad-card__top">
                            <div className="turno-card__avatar">{turno.medicoNombre.split(" ").pop().charAt(0)}</div>
                            <div>
                                <p className="turno-card__medico">{turno.medicoNombre}</p>
                                <p className="turno-card__especialidad">{turno.sedeNombre}</p>
                            </div>
                        </div>

                        <div className="turno-card__meta">
                            <span><IconClock /> {formatearHora(turno.fechaHora)}</span>
                            <span><IconMapPin /> {turno.sedeNombre}</span>
                        </div>

                        <div className="wizard-servicios">
                            {turno.servicios.map((servicio) => {
                                const cobertura = getCoberturaParaServicio(plan, servicio.id);
                                const { costoFinal, nivel } = calcularCostoConCobertura(servicio, cobertura);
                                return (
                                    <div key={servicio.id} className="wizard-servicio">
                                        <div className="wizard-servicio__info">
                                            <span className="wizard-servicio__nombre">{servicio.nombre}</span>
                                            <BadgeCobertura nivel={cobertura ? nivel : "NO_CUBIERTA"} />
                                        </div>
                                        <span className="wizard-servicio__costo">
                                            {plan && nivel === "TOTAL" ? (
                                                <span className="costo-gratis">Gratis</span>
                                            ) : (
                                                <>
                                                    {plan && nivel === "PARCIAL" && (
                                                        <span className="costo-original">${(servicio.costoConsulta ?? 0).toLocaleString("es-AR")}</span>
                                                    )}
                                                    <span className="costo-final">${costoFinal.toLocaleString("es-AR")}</span>
                                                </>
                                            )}
                                        </span>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                ))}
            </div>
        )}
    </div>
);

export default PasoTurno;
